import {getRequest} from "./api";

export const initMenu = (router, store) => {
    if (store.state.routes.length > 0) {
        return;
    }
    getRequest("/system/config/menu").then(data => {
        if (data) {
            let fmtRoutes = formatRoutes(data);
			console.log("fmtRoutes")
            router.addRoutes(fmtRoutes);
			console.log("addRoutes")
            store.commit('initRoutes', fmtRoutes);
            store.dispatch('connect');
        }
    })
}
export const formatRoutes = (routes) => {
    let fmRoutes = [];
    routes.forEach(router => {
        let {
            path,
            component,
            name,
            meta,
            iconCls,
            children
        } = router;
        if (children && children instanceof Array) {
            children = formatRoutes(children);
        }
        let fmRouter = {
            path: path,
            name: name,
            iconCls: iconCls,
            meta: meta,
            children: children,
            component(resolve) {
                if (component.startsWith("Home")) {
                    require(['../views/' + component + '.vue'], resolve);
                } else if (component.startsWith("Emp")) {
                    require(['../views/emp/' + component + '.vue'], resolve);
                } else if (component.startsWith("Per")) {
                    require(['../views/per/' + component + '.vue'], resolve);
                } else if (component.startsWith("Sal")) {
                    require(['../views/sal/' + component + '.vue'], resolve);
                } else if (component.startsWith("Sta")) {
                    require(['../views/sta/' + component + '.vue'], resolve);
                } else if (component.startsWith("Sys")) {
                    require(['../views/sys/' + component + '.vue'], resolve);
                } else if (component.startsWith("Tenants")) {
                    require(['../views/tenant/' + component + '.vue'], resolve);
                } else if (component.startsWith("Questions")) {
                    require(['../views/question/' + component + '.vue'], resolve);
                } else if (component.startsWith("Formula")) {
                    require(['../views/formula/' + component + '.vue'], resolve);
                } else if (component.startsWith("Music")) {
                    require(['../views/music/' + component + '.vue'], resolve);
                } else if (component.startsWith("Graphic")) {
                    require(['../views/graphic/' + component + '.vue'], resolve);
                } else if (component.startsWith("Quota")) {
                    require(['../views/quota/' + component + '.vue'], resolve);
                } else if (component.startsWith("HumanBody")) {
                    require(['../views/humanBody/' + component + '.vue'], resolve);
                } else if (component.startsWith("Commodity")) {
                    require(['../views/commodity/' + component + '.vue'], resolve);
                } else if (component.startsWith("Order")) {
                    require(['../views/order/' + component + '.vue'], resolve);
                } else if (component.startsWith("Customer")) {
                    require(['../views/customer/' + component + '.vue'], resolve);
                } else if (component.startsWith("Answersheet")) {
                    require(['../views/answersheet/' + component + '.vue'], resolve);
                } else if (component.startsWith("QuestionModels")) {
                    require(['../views/question/' + component + '.vue'], resolve);
                } else if (component.startsWith("RoleManager")) {
                    require(['../views/permission/' + component + '.vue'], resolve);
                } else if (component.startsWith("UserManager")) {
                    require(['../views/permission/' + component + '.vue'], resolve);
                } else if (component.startsWith("QmAuthManager")) {
                    require(['../views/permission/' + component + '.vue'], resolve);
                }
            }
        }
        fmRoutes.push(fmRouter);
    })
    return fmRoutes;
}